<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog update-401-period-dialog" append-to-body :before-close="onClose">
        <template slot="title"> 設定申報資訊 </template>
        <el-form ref="form" :model="form" class="detail-row">
            <el-form-item label="申報期別" prop="period">
                <el-select v-model="form.period" placeholder="請選擇" value-key="key">
                    <el-option
                        v-for="item in periodList"
                        :disabled="isPeriodDisabled(item)"
                        :key="`${item.year}-${item.value}-${item.period}`"
                        :label="`${item.year - 1911}年 ${item.period}`"
                        :value="item"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-button type="" @click="onClose">取消</el-button>
            <el-button v-if="!isQR()" type="primary" :loading="isLoading" :disabled="!form.period" @click="onSubmit"> 確認申報 </el-button>
        </el-form>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    props: {
        visible: Boolean,
    },
    computed: {
        ...mapState({
            periodList: (state) => state.businessTax.periodList,
            data: (state) => state.businessTax.datas,
            selectedItems: (state) => state.businessTax.selectedItems,
            selectedInvoiceItems: (state) => state.businessTax.selectedInvoiceItems,
        }),
    },
    data() {
        return {
            form: { period: null },
            isLoading: false,
        };
    },
    methods: {
        ...mapMutations({
            onClearSelection: 'businessTax/onClearSelection',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    try {
                        await this.onMarkDeclareStatus();
                        this.updateData();
                        this.onClearSelection();
                        this.onClose();
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        async onMarkDeclareStatus() {
            const INVOICE_LIST = _.chain(this.selectedItems)
                .filter((o) => o.ioo)
                .map((o) => ({
                    sno: o.sno,
                    declareStatus: true,
                    updateType: o.typ > 0 ? 1 : 2,
                    prefixYear: this.form.period.year,
                    prefixMonth: this.form.period.value,
                }))
                .value();

            const TRAN_INVOICE_LIST = _.chain(this.selectedItems)
                .filter((o) => o.isTranInovice)
                .map((o) => ({
                    sno: o.sno,
                    declareStatus: true,
                    updateType: o.typ > 0 ? 1 : 2,
                    prefixYear: this.form.period.year,
                    prefixMonth: this.form.period.value,
                }))
                .value();

            const TCIN_LIST = _.chain(this.selectedItems)
                .filter((o) => o.taxCredited)
                .map((o) => ({
                    sno: o.sno,
                    declareStatus: 1,
                    prefixYear: this.form.period.year,
                    prefixMonth: this.form.period.value,
                }))
                .value();
            const NON_TCIN_LIST = _.chain(this.selectedItems)
                .filter((o) => o.payoo)
                .map((o) => ({
                    sno: o.sno,
                    declareStatus: 1,
                    prefixYear: this.form.period.year,
                    prefixMonth: this.form.period.value,
                }))
                .value();

            const errorList = [];

            if (INVOICE_LIST.length) {
                await this.$api({
                    url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                    data: { invoices: INVOICE_LIST, invoiceType: 1 },
                    method: 'POST',
                });
            }
            if (TRAN_INVOICE_LIST.length) {
                await this.$api({
                    url: 'AccountingSummaryPage/UpdateInvoice401DeclareStatus',
                    data: { invoices: TRAN_INVOICE_LIST, invoiceType: 2 },
                    method: 'POST',
                });
            }
            if (TCIN_LIST.length) {
                await this.$api({
                    url: 'AccountingSummaryPage/UpdatePaymentInvoiceDeclareStatus',
                    data: { payments: TCIN_LIST },
                    method: 'POST',
                });
            }
            if (NON_TCIN_LIST.length) {
                const resp = await this.$api({
                    url: 'AccountingSummaryPage/UpdatePayment401DeclareStatus',
                    data: { payments: NON_TCIN_LIST },
                    method: 'POST',
                });
                if (resp.data?.fail) errorList.push(...resp.data.fail);
            }

            if (errorList.length) {
                await this.$msgbox({
                    title: '',
                    message: `以下來源請款單已被退件，${errorList.length} 筆項目無法列入申報：\n${errorList.join(', ')} `,
                    confirmButtonText: '我瞭解了',
                    closeOnClickModal: false,
                    showClose: false,
                });
            }
        },
        onClose() {
            this.form.period = null;
            this.$emit('close');
        },
        getPeriodYear() {
            return _.find(this.periodList, ['value', this.form.period]).year;
        },
        isPeriodDisabled({ year, months }) {
            let ret;
            this.selectedInvoiceItems.forEach((item) => {
                const IS_MONTH_MATCH = months.includes(moment(item.foO_DAT).month() + 1);
                const IS_YEAR_MATCH = moment(item.foO_DAT).year() === year;
                ret = !(IS_MONTH_MATCH && IS_YEAR_MATCH);
            });
            return ret;
        },
    },
};
</script>

<style lang="scss">
.update-401-period-dialog {
    display: flex;
    .el-dialog {
        width: 100%;
        max-width: 550px;
        margin: auto !important;
    }
}
</style>
